import './app.scss';

import './preload';
import share from './data/share.json';
import { initShareButtons } from './js/shareResult';

initShareButtons('.results-page .share__item', share.result);
